// 広告LP (campaign-1〜4) の LINE の行き先。LP と LIFF のページの両方から読むので、軽いここに置く
// 行き先は /women/line/lp に集め、その先の LINE の計測リンクは配備なしで差し替えられるようにする (2026-10-06 オーナーの指示)
export const LP_LINE_URL = "https://yumesaku.tech/women/line/lp";

// /women/line/lp の先にある LINE の計測リンクのコード。既存の友だちをウェルカムに入れるとき、
// どの LP から来たかとして CRM に渡す。計測リンクを差し替えたら、ここも合わせる
export const LP_TRACKED_LINK_CODE = "lp-9-27";

// LP の訪問と LINE ID を確実に結ぶための LIFF アプリ「ゆめさく女性 LP」(2026-10-01 に作成)。
// エンドポイントは /women/liff/lp-follow。紹介用の LIFF (LuaGate 紹介リンク) とは混ぜない
export const LIFF_LP_ID = "2008555780-9dGsJ4Xf";

// LIFF を通す LP。まず1本だけで、友だち追加の率が落ちないかを比べる
export const LIFF_LP_SLUGS = ["campaign-2"];

// LP 計測のセッション ID を、LINE ボタンが読めるよう sessionStorage にも置く
export const LP_SESSION_STORAGE_KEY = "lp_session_id";

// visit_start の応答で受け取る sessionId の署名。{ sessionId, sig } を置き、visit_update と events に付ける
export const LP_VISIT_SIG_STORAGE_KEY = "lp_visit_sig";

export function isLpSessionId(value: unknown): value is string {
  return typeof value === "string" && /^\d{10,16}-[a-z0-9]{1,20}$/.test(value);
}

// visit_start の署名を出してよい sessionId の形。広告 LP の形 (isLpSessionId) に加え、HP と職種診断が使う UUID
export function isSignableVisitSessionId(value: unknown): value is string {
  return (
    isLpSessionId(value) ||
    (typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value))
  );
}
